<template>
    <YesNo :label="schema.label" 
        :question="schema.question" color="blue" 
        :value="value[schema.name]" 
        @input="$emit('change', $event)"
        @focus="$emit('focus', $event)"
        @contextmenu.native.prevent="$emit('focus', $event)"
    />
</template>

<script>

import YesNo from '@/ui-elements/YesNo'

export default {

    data() {
        return {
        
        }
    },

    components: {
        YesNo, 
    },
    
    props: {
        value: Object,
        schema: Object, 
    },

    computed: {

    },

    methods: {

    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// YesNoControl.vue?e2cdbe6e